import script from "./numberprefix.vue?vue&type=script&lang=ts&setup=true"
export * from "./numberprefix.vue?vue&type=script&lang=ts&setup=true"

import "./numberprefix.vue?vue&type=style&index=0&id=3cf24a98&scoped=true&lang=less"

import exportComponent from "/Users/user/Projects/simweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cf24a98"]])

export default __exports__